import React from 'react';
import { Field } from 'formik';
import CustomInputTextComponent from 'components/Form/CustomInputTextComponent';
const GeneralForm = () => (
	<div>
		<Field
			type='text'
			name='code'
			customlabel='code'
			component={CustomInputTextComponent}
			required
		/>
		<span style={{ fontStyle: 'italic' }}>
			Afin d'utiliser ce type de prélèvement dans une réponse, réutiliser le
			même code
		</span>
		<Field
			type='text'
			name='name'
			customlabel='Nom'
			component={CustomInputTextComponent}
			required
		/>
		<Field
			customlabel='Prix'
			type='number'
			name='price'
			id='price'
			component={CustomInputTextComponent}
			required
		/>
	</div>
);

export default GeneralForm;
